import { Component } from '@angular/core';

@Component({
  selector: 'mtm-yellow-circle-icon',
  templateUrl: './yellow-circle-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class YellowCircleIconComponent {}
